<template>
  <span>{{ fechaYHoraComponent }}</span>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  name: "fechaYHoraComponent",
  computed: {
    fechaYHoraComponent() {
      return this.$moment(this.params.data.creacion).format("DD/MM/YYYY H:mm");
    },
  },
});
</script>
